<template>
  <div>
    <div class="section">
      <div class="container">
        
        <div class="section__content center login" v-if="isAoc === true">
          
          <form v-on:submit.prevent="consent_gateway" >
            <h1 class="std__subtile">{{ $t("login_title") }}</h1>
            <h2 class="std__subtile md">{{ $t("subscribe_messsage") }}</h2>
            <div class="btnContainer">
              <button type="submit" class="mobiBtn">{{ $t("subscribe") }}</button>
            </div>
          </form>
        </div>
        <div class="section__content center login" v-else>
          <form v-on:submit.prevent="login">
            <h1 class="std__subtile">{{$t("login_title")}}</h1>
            <h2 class="std__subtile md">
              {{$t("confirmation")}}
            </h2>
            <div class="mobiForElm">
              <input
                type="tel"
                class="mobiForElm__input"
                v-model="msisdn"
                maxlength="14"
                placeholder
              />
            </div>
            <div class="btnContainer">
              <button type="submit" class="mobiBtn">{{$t("submit")}}</button>
            </div>
            <div
              v-if="showStatusAlert"
              class="alert alert-danger col-md-3"
              role="alert"
            >
              <span v-if="lang_prizeo === 'english'">{{ status }}</span>
              <span v-if="lang_prizeo !== 'english'">{{ statusTran }}</span>
              <!-- <span v-if="lang_prizeo === 'english'">{{ status }}</span>
              <span v-if="lang_prizeo === 'arabic'">{{ statusAR }}</span>
              <span v-if="lang_prizeo === 'greek'">{{ statusGR }}</span>
              <span v-if="lang_prizeo === 'malay' || lang_prizeo === 'indonesian'">{{ statusMYID }}</span> -->
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
            <div
              v-if="showMsisdnAlert"
              class="alert alert-danger col-md-5"
              role="alert"
            >
              {{$t("valid_number")}}
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import prizeo from "../../../router/prizeo";
import country_list from "../../../locales/country_list.json";
import EventBus from "../../EventBus.vue";
import { mapActions, mapGetters } from "vuex";

const proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

export default {
  data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el",
      isAoc: false
    };
  },
  created(){
    this.getPrefix(this.country_prizeo);
    if (
      this.gcid_prizeo === "289" ||
      this.gcid_prizeo === "290" ||
      this.gcid_prizeo === "291" 
     
    ) {
      this.isAoc = true;
    }
  },
  computed: mapGetters(["lang_prizeo", "gcid_prizeo" ,"country_prizeo"]),
  methods: {
    getPrefix(country){
      for (let [key, value] of Object.entries(country_list)) {
        if(country == key){
          this.msisdn = '+'+value.prefix;
        }
      }
    },
    close(){
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    consent_gateway() {
      if (this.gcid_prizeo == "289") {
        window.location =
          "https://www.prizeo.vip/campaign/click.php?offer_id=3138&aff_sub5=test&aff_id=217";
      }else if (this.gcid_prizeo == "291") {
        window.location =
          "https://www.prizeo.vip/campaign/click.php?offer_id=3139&aff_sub5=test&aff_id=217";
      } else if (this.gcid_prizeo == "290") {
        window.location =
          "https://www.prizeo.vip/campaign/click.php?offer_id=3140&aff_sub5=test&aff_id=217";
      } else {
        alert("Invalid GCID");
      }
    },
    login() {
      let regex = /^\d{9,}$/;
      let a = this.msisdn;
      this.msisdn = a.replace("+","");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          let gcid = "";
          if(this.gcid_prizeo != ""){
            gcid = this.gcid_prizeo
          }else{
            //dummy gcid
            gcid = "264";
          }
          
          let data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          const login = {
            url: `${proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=${data.msisdn}&gcid=${data.gcid}&verbose=${data.verbose}`),
            method: "POST"
          };
          this.$axios(login)
            .then(res => {
               var response = JSON.parse(res.data.contents);
              if (response.status == "active") {
                localStorage.setItem("userToken_prizeo", response.token);
                localStorage.setItem("userProfile_prizeo", res.data.contents)
                this.msisdn = "";
                // this.emitMethod();
                this.login_prizeo("loggedin");
                prizeo.push({ name: "Main" }).catch(err => {});
                location.reload();
              } else if (response.status == "inactive") {
                this.showStatusAlert = true;
                this.showMsisdnAlert = false;
                let status = response.status.replace( response.status.toUpperCase());
                this.status = status;

                for (let [key, value] of Object.entries(country_list)) {
                  if(this.country_prizeo == key){
                    let status_lang = require(`../../../locales/prizeo/${value.language}.json`);
                    this.statusTran = status_lang.status;
                  }
                }
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      }
    },
    ...mapActions(["login_prizeo"])
    // emitMethod() {

    // }
  }
};
</script>

<style lang="scss" scoped>
.section__content.login {
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  text-align: center;
}
input.mobiForElm__input {
  direction: ltr;
}
.alert {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/prizeo/Login.vue